/**
 * Shared channel/touchpoint constants used across the application
 */

export interface ChannelColorConfig {
  color: string;
  ringColor: string;
  label: string;
}

/**
 * Channel color and label configurations
 * Keys should be in kebab-case (e.g., "direct-email")
 */
export const CHANNEL_COLORS: Record<string, ChannelColorConfig> = {
  "direct-email": {
    color: "bg-supporting-blue",
    ringColor: "ring-supporting-blue/20",
    label: "Direct Email",
  },
  "bulk-email": {
    color: "bg-supporting-blue/70",
    ringColor: "ring-supporting-blue/15",
    label: "Bulk Email",
  },
  "phone-call": {
    color: "bg-supporting-orange",
    ringColor: "ring-supporting-orange/20",
    label: "Phone Call",
  },
  meeting: {
    color: "bg-supporting-purple",
    ringColor: "ring-supporting-purple/20",
    label: "Meeting",
  },
  "web-session": {
    color: "bg-supporting-green",
    ringColor: "ring-supporting-green/20",
    label: "Web Session",
  },
  chatbot: {
    color: "bg-supporting-yellow",
    ringColor: "ring-supporting-yellow/20",
    label: "Chatbot",
  },
  sms: {
    color: "bg-supporting-green/70",
    ringColor: "ring-supporting-green/15",
    label: "SMS",
  },
  social: {
    color: "bg-supporting-purple/70",
    ringColor: "ring-supporting-purple/15",
    label: "Social",
  },
  multiple: {
    color: "bg-muted-foreground/50",
    ringColor: "ring-muted-foreground/20",
    label: "Multiple",
  },
};

/**
 * Get the label for a channel/touchpoint type
 * @param channelKey The channel key in kebab-case
 * @returns The human-readable label
 */
export function getChannelLabel(channelKey: string): string {
  // Check main channel colors first
  if (CHANNEL_COLORS[channelKey]) {
    return CHANNEL_COLORS[channelKey].label;
  }

  // Fallback: convert kebab-case to Title Case
  return channelKey
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
}
